module.exports = __webpack_public_path__ + "img/question-mark.e9167aae.svg";